export default __webpack_public_path__ + "static/media/app_store_hover.fd9e7687.svg";